import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X, Phone, Star } from "lucide-react";
import { useNavigate } from "react-router-dom";
import ProcessedLogo from "./ProcessedLogo";
import Navigation from "./Navigation";

const Header = ({ onBookingClick }: { onBookingClick: () => void }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-[100] bg-background/95 backdrop-blur-md border-b border-border/10 shadow-sm">
      {/* Top Bar */}
      <div className="bg-primary text-primary-foreground py-2">
        <div className="container mx-auto px-4 flex justify-between items-center text-sm">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-1">
              <Star className="h-4 w-4 fill-current" />
              <span>Michigan's #1 Organizing Service</span>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <a href="tel:+16167270343" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
              <Phone className="h-4 w-4" />
              <span className="font-medium">616 727-0343</span>
            </a>
            <span className="hidden sm:inline">Free Consultation Available</span>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <ProcessedLogo />
          <div className="hidden lg:block">
            <p className="text-sm text-muted-foreground font-medium">
              Transform Your Space • Reclaim Your Time • Love Your Home
            </p>
          </div>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:block">
          <Navigation onBookingClick={onBookingClick} />
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="absolute top-full left-0 right-0 bg-background border-t border-border md:hidden shadow-lg">
            <nav className="flex flex-col p-4 space-y-4">
              <button
                onClick={() => scrollToSection("services")}
                className="text-left text-foreground hover:text-primary transition-colors font-medium"
              >
                Organizing Services
              </button>
              <button
                onClick={() => scrollToSection("about")}
                className="text-left text-foreground hover:text-primary transition-colors font-medium"
              >
                About Us
              </button>
              <button
                onClick={() => navigate('/blog')}
                className="text-left text-foreground hover:text-primary transition-colors font-medium"
              >
                Organization Tips
              </button>
              <button
                onClick={() => navigate('/resources')}
                className="text-left text-foreground hover:text-primary transition-colors font-medium"
              >
                Free Resources
              </button>
              <a href="tel:+16167270343" className="text-left text-foreground hover:text-primary transition-colors font-medium">
                Call 616 727-0343
              </a>
              <Button onClick={onBookingClick} className="luxury-gradient text-primary-foreground font-medium w-full">
                Get Free Estimate
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;